const ContactInfo = () => (
  <div className="bg-[#0F3D22] rounded-2xl p-8 text-white h-full">
    <h2 className="text-2xl font-bold mb-2">Get In Touch</h2>
    <p className="text-green-200 text-sm leading-relaxed mb-8">
      Whether you need a pickup, want to drop off electronics, or have questions about data destruction — we&apos;re here to help.
    </p>

    <div className="space-y-6">
      <div className="flex gap-4 items-start">
        <div className="w-10 h-10 flex items-center justify-center bg-[#1B6B3A] rounded-xl shrink-0 mt-0.5">
          <i className="ri-map-pin-line text-[#74C69D] text-lg"></i>
        </div>
        <div>
          <div className="font-semibold text-sm mb-1">Drop-off Locations</div>
          <address className="not-italic text-green-200 text-sm leading-relaxed">
            2542 W. 3rd Street, Los Angeles, CA 90057<br />
            4902 W. Slauson Ave, Los Angeles, CA 90056
          </address>
        </div>
      </div>

      <div className="flex gap-4 items-start">
        <div className="w-10 h-10 flex items-center justify-center bg-[#1B6B3A] rounded-xl shrink-0">
          <i className="ri-phone-line text-[#74C69D] text-lg"></i>
        </div>
        <div>
          <div className="font-semibold text-sm mb-1">Phone</div>
          <a href="tel:+12136001000" className="text-green-200 text-sm hover:text-white transition-colors cursor-pointer">
            (213) 600-1000
          </a>
        </div>
      </div>

      <div className="flex gap-4 items-start">
        <div className="w-10 h-10 flex items-center justify-center bg-[#1B6B3A] rounded-xl shrink-0">
          <i className="ri-mail-line text-[#74C69D] text-lg"></i>
        </div>
        <div>
          <div className="font-semibold text-sm mb-1">Email</div>
          <a href="mailto:info@greenly.us" className="text-green-200 text-sm hover:text-white transition-colors cursor-pointer">
            info@greenly.us
          </a>
        </div>
      </div>

      <div className="flex gap-4 items-start">
        <div className="w-10 h-10 flex items-center justify-center bg-[#1B6B3A] rounded-xl shrink-0">
          <i className="ri-time-line text-[#74C69D] text-lg"></i>
        </div>
        <div>
          <div className="font-semibold text-sm mb-1">Business Hours</div>
          <div className="text-green-200 text-sm leading-relaxed">
            Monday – Friday: 8:00am – 5:00pm<br />
            Saturday: 9:00am – 2:00pm<br />
            Sunday: Closed
          </div>
        </div>
      </div>

      <div className="flex gap-4 items-start">
        <div className="w-10 h-10 flex items-center justify-center bg-[#1B6B3A] rounded-xl shrink-0">
          <i className="ri-award-line text-[#74C69D] text-lg"></i>
        </div>
        <div>
          <div className="font-semibold text-sm mb-1">CalRecycle Certification</div>
          <div className="text-green-200 text-sm">CEWD-127531</div>
        </div>
      </div>
    </div>

    <div className="mt-8 pt-8 border-t border-white/10 flex items-center gap-3">
      {[
        { icon: 'ri-facebook-fill', href: '#' },
        { icon: 'ri-twitter-x-fill', href: '#' },
        { icon: 'ri-linkedin-fill', href: '#' },
        { icon: 'ri-instagram-line', href: '#' },
      ].map((s) => (
        <a
          key={s.icon}
          href={s.href}
          rel="nofollow"
          className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#4CAF82] transition-colors cursor-pointer"
        >
          <i className={`${s.icon} text-sm`}></i>
        </a>
      ))}
    </div>
  </div>
);

export default ContactInfo;
